





























































































































import password from '@/store/types/password';
import { itemsRoute } from '@/ts/navegationLinks';
import { TeipNotifications } from '@/util/teipNotifications';
import { AxiosError } from 'axios';
import { ValidationProvider } from 'vee-validate';
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'ConfigurationCurrentUser',
  data: () => ({
    data: [
      {
        icon: 'fas fa-eye',
        name: 'current_password',
        value: '',
        type: 'password',
      },
      { icon: 'fas fa-eye', name: 'password', value: '', type: 'password', },
      {
        icon: 'fas fa-eye',
        name: 'password_confirmation',
        value: '',
        type: 'password',
      }
    ],
    items: [
      {
        id: 1,
        icon: 'fas fa-key',
        title: 'Contraseña',
        route: 'my-profile-config',
      }
    ] as itemsRoute[],
  }),
  methods: {
    ...mapActions({
      resetPasswordUser: `passwordModule/${password.actions.RESET_PASSWORD_CURRENT_USER}`,
    }),
    updatePassword(): void {
      const data = {
        current_password: this.data[0].value,
        password: this.data[1].value,
        password_confirmation: this.data[2].value,
      };
      const notification = new TeipNotifications();
      this.resetPasswordUser(data)
        .then(() => {
          notification.success('¡Éxito!', 'Contraseña actualizada');

          this.data[0].value = '';
          this.data[1].value = '';
          this.data[2].value = '';
          (this.$refs.formUpdatePassword as InstanceType<typeof ValidationProvider>).reset();
        })
        .catch((error: AxiosError) => {
          if (error.response?.status === 422) {
            const typeError = error.response.data.error;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let errors: any = [];
            if (typeof typeError === 'string') {
              errors.current_password = 'Contraseña actual incorrecta';
            } else {
              errors = typeError;
            }
            (this.$refs.formUpdatePassword as InstanceType<typeof ValidationProvider>)
              .setErrors(errors);
          } else {
            notification.warning('¡Error!', 'No hemos podido actualizar');
          }
        });
    },
    showPassword(input: string): void {
      const position = this.data.map((inp) => inp.name).indexOf(input);
      if (this.data[position].type === 'password') {
        this.data[position].type = 'text';
        this.data[position].icon = 'fas fa-eye-slash';
      } else {
        this.data[position].type = 'password';
        this.data[position].icon = 'fas fa-eye';
      }
    },
    cancel(): void {
      this.$router.push({
        name: 'my-profile',
      });
    },
  },
});

